module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row col-xs middle-xs top-bar-data"
  }, [_c('div', {
    staticClass: "items-center top-bar-data-style"
  }, [_c('div', {
    staticClass: "display-data"
  }, [_c('div', [_vm._v("\n        Upgrade Code:\n        "), _c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.upgradeCodeTooltip),
      expression: "upgradeCodeTooltip"
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "color": "#848484"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "b school-data-style"
  }, [_vm._v(_vm._s(_vm.upgradeCode))])]), _vm._v(" "), _c('div', {
    staticClass: "display-data"
  }, [_c('div', [_vm._v("\n        License Details:\n        "), _c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.licenseDetailsTooltip),
      expression: "licenseDetailsTooltip"
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "color": "#848484"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "b school-data-style"
  }, [_vm._v(_vm._s(_vm.licenseDetailsDisplay))])]), _vm._v(" "), _c('div', {
    staticClass: "display-data"
  }, [_c('Tooltip', {
    attrs: {
      "text": _vm.licensesUsedTooltip,
      "styleTooltip": ""
    }
  }, [_c('button', [_vm._v("\n          Licenses Used:"), _c('i', {
    staticClass: "fa ml-1 fa-info-circle",
    staticStyle: {
      "color": "#848484"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), (_vm.licensesUsedDisplay) ? _c('div', {
    staticClass: "b school-data-style"
  }, [_vm._v("\n        " + _vm._s(_vm.licensesUsedDisplay) + "\n      ")]) : (!_vm.licensesUsedDisplay && _vm.licenseDetailsDisplay) ? _c('div', {
    staticClass: "b school-data-style"
  }, [_vm._v("\n        0\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "display-data"
  }, [_c('div', [_vm._v("\n        Expiration:\n        "), _c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.expirationDateTooltip),
      expression: "expirationDateTooltip"
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "color": "#848484"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "b school-data-style"
  }, [_vm._v(_vm._s(_vm.expirationDate))])])]), _vm._v(" "), (_vm.hasAdminAdminPermission) ? _c('div', {
    staticClass: "col-xs add-new-users-style",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('button', {
    staticClass: "px-8 py-2 rounded cursor-pointer bg-primary text-white text-sm font-semibold disabled:opacity-50",
    staticStyle: {
      "margin-left": "0px"
    },
    on: {
      "click": _vm.goToAddUsers
    }
  }, [_vm._v("\n      ADD NEW USERS\n    ")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-c7f47aba!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/adminPortalUsers/adminPortalUsersTopBar.vue
// module id = 2029
// module chunks = 61